var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEyeShow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.668 10.066a2.667 2.667 0 1 1-5.334 0 2.667 2.667 0 0 1 5.334 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.65 5.153c1.603 1.035 3.033 2.484 4.136 4.189a1.341 1.341 0 0 1 .004 1.448c-1.098 1.72-2.526 3.173-4.128 4.205-1.767 1.137-3.73 1.738-5.675 1.738-1.99 0-3.903-.583-5.68-1.734-1.578-1.022-2.995-2.472-4.095-4.194a1.33 1.33 0 0 1 .027-1.48c1.335-1.915 2.873-3.402 4.57-4.42C6.473 3.906 8.215 3.4 9.987 3.4c1.93 0 3.889.606 5.662 1.753Zm-7.872 8.24a4 4 0 1 0 4.445-6.653 4 4 0 0 0-4.445 6.652Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeShow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye-show.6699aa6fa84655e75bf95dffae803cff.svg";